import { createStore } from "vuex";
import { namespace } from 'vuex-class';
import { suggest } from './modules/suggest';
import { searchCriteria } from './modules/searchCriteria';
import { user } from './modules/user';
import { search } from './modules/search';
import { support } from './modules/support';
import { hotel } from './modules/hotel';
import { booking } from './modules/booking';
import { card } from './modules/card'; 
import { car } from './modules/car';
import { flight } from './modules/avia';
import { flightsHistory } from './modules/avia';
import { order } from './modules/order';
 
const store = createStore({
  modules: { 
    suggest, 
    searchCriteria, 
    user, 
    search, 
    support, 
    hotel, 
    booking, 
    card, 
    car, 
    flight,
    flightsHistory, 
    order,
  },
  strict: process.env.NODE_ENV === 'development'
});

export default store;

export const bookingModule = namespace('booking');
export const hotelModule = namespace('hotel');
export const userModule = namespace('user');
export const suggestModule = namespace('suggest');
export const cardModule = namespace('card');
export const searchCriteriaModule = namespace('searchCriteria');
export const searchModule = namespace('search');
export const supportModule = namespace('support');
export const carModule = namespace('car');
export const flightModule = namespace('flight');
export const flightsHistoryModule = namespace('flightsHistory');
export const orderModule = namespace('order');
